import { Cloudy } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const CloudsIcon = createLucideIcon(Cloudy);
